export const shownNumber = (v) => {
    if (v === '' || v == null) return '';
    const n = Number(v);
    return Number.isFinite(n) ? Math.round(n) : v;
};

export const layoutSummary = (tool, withSize = true) => {
    const g = tool?.geometry || {};
    const w = Math.round(Number(g.width) || 0);
    const h = Math.round(Number(g.height) || 0);
    const page = tool?.page ? `Page ${tool.page}` : null;
    const position = Number.isFinite(Number(g.left)) && Number.isFinite(Number(g.top))
        ? `Left ${Math.round(Number(g.left))} · Top ${Math.round(Number(g.top))}`
        : null;
    const size = withSize && w > 0 && h > 0 ? `${w} × ${h}` : null;
    return [page, position, size].filter(Boolean).join(' · ');
};

export const animationSummary = (tool) => {
    const animation = tool?.value?.animation;
    if (!animation) return 'None';
    const words = String(animation).replace(/([A-Z])/g, ' $1').trim();
    return words.charAt(0).toUpperCase() + words.slice(1);
};

export const clickActionSummary = (tool) => {
    const value = tool?.value || {};
    const matches = [
        [tool?.action == 'none', 'No action'],
        [tool?.action === 'desiredaction' || (tool?.dropdown_data && Object.keys(tool.dropdown_data).length > 0), 'Hide / Reveal'],
        [tool?.action === 'page' || !!value.page_link, value.page_link ? `Jump to page ${value.page_link}` : 'Jump to page'],
        [tool?.action === 'href' || (!value.kdf_title && !!(value.url || value.phone || value.mail)), 'Open link'],
        [tool?.action === 'link_and_jump' || !!(value.lj_page_link && (value.lj_url || value.lj_phone || value.lj_mail)), 'Link and jump'],
        [tool?.action === 'on' || !!value.light_box, 'Reveal ClickPop'],
        [tool?.action === 'kdf' || value.kdf_title?.length > 0, 'Link to KDF'],
    ].filter(([hit]) => hit);
    return matches.length ? matches[matches.length - 1][1] : '';
};

export const appearanceSummary = (tool, withTransparency) => {
    const t = parseFloat(tool?.transparency);
    const opacity = withTransparency ? `${Number.isFinite(t) ? Math.round(t * 100) : 100}%` : null;
    const bg = tool?.value?.bg_color ? `background ${tool.value.bg_color}` : null;
    return [opacity, bg].filter(Boolean).join(' · ');
};

export const transformSummary = (tool) => `${Number(tool?.rotate) || 0}° · ${tool?.flip === -1 ? 'flipped' : 'no flip'}`;

export const metadataSummary = (tool) => {
    const count = Array.isArray(tool?.tags) ? tool.tags.length : 0;
    return count ? `${count} tag${count > 1 ? 's' : ''}` : 'No tags';
};

export const languagesSummary = (tool, languages = []) => {
    const selected = Array.isArray(tool?.other_files) ? tool.other_files : [];
    if (!selected.length) return 'This edition only';
    const names = languages
        .filter((l) => selected.includes(l?.id ?? l?.docs_file_id))
        .map((l) => l?.language?.name || l?.language_name || l?.language?.locale)
        .filter(Boolean);
    return names.length ? `Also on ${names.join(', ')}` : `Also on ${selected.length} edition${selected.length > 1 ? 's' : ''}`;
};
